import React from 'react';
import GracePeriodBanner from './GracePeriodBanner';
import { useFeatureLimitsQuery } from '../hooks/queries/useFeatureLimits';

/**
 * Self-contained grace period banner that fetches billing data via
 * useFeatureLimitsQuery. Renders nothing if no grace period is active.
 */
const GracePeriodBannerConnected: React.FC = () => {
  const { limits } = useFeatureLimitsQuery();

  if (!limits?.graceTier || !limits?.graceExpiresAt) return null;

  return (
    <div className="max-w-[1400px] w-full mx-auto px-3 sm:px-6">
      <GracePeriodBanner
        graceTier={limits.graceTier}
        graceExpiresAt={limits.graceExpiresAt}
        actualPlan={limits.plan}
      />
    </div>
  );
};

export default GracePeriodBannerConnected;
